(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const decrementBtn = event.target.closest('[data-quantity-decrement]');
    const incrementBtn = event.target.closest('[data-quantity-increment]');
    if (!decrementBtn && !incrementBtn) return;

    const quantityInput = (decrementBtn || incrementBtn)
      .closest('.cart-item__quantity')
      .querySelector('[data-quantity-input]');
    const min = parseInt(quantityInput.min, 10) || 0;
    const currentValue = parseInt(quantityInput.value, 10) || min;

    quantityInput.value = decrementBtn ? Math.max(min, currentValue - 1) : currentValue + 1;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["forest-map-teaser"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const sparkleColors = ['#f4b8cf', '#f6d77a', '#a9d3f0', '#c8b6ec', '#a8dcb9'];

    const placeBubble = (map, bubble, spot) => {
      const pad = 6;
      const gap = 10;
      const mapRect = map.getBoundingClientRect();
      const spotRect = spot.getBoundingClientRect();
      const width = bubble.offsetWidth;
      const height = bubble.offsetHeight;
      const centerX = spotRect.left - mapRect.left + spotRect.width / 2;

      const left = Math.min(Math.max(centerX - width / 2, pad), Math.max(mapRect.width - width - pad, pad));
      let top = spotRect.top - mapRect.top - height - gap;
      let below = false;
      if (top < pad) {
        top = spotRect.bottom - mapRect.top + gap;
        below = true;
      }
      top = Math.max(pad, Math.min(top, mapRect.height - height - pad));

      const tailX = Math.min(Math.max(centerX - left, 16), width - 16);
      bubble.style.left = `${left}px`;
      bubble.style.top = `${top}px`;
      bubble.style.setProperty('--tail-x', `${tailX}px`);
      bubble.classList.toggle('is-below', below);
    };

    const sparkle = (map, spot) => {
      if (reduceMotion()) return;
      const mapRect = map.getBoundingClientRect();
      const spotRect = spot.getBoundingClientRect();
      const x = spotRect.left - mapRect.left + spotRect.width / 2;
      const y = spotRect.top - mapRect.top + spotRect.height / 2;
      for (let i = 0; i < 7; i += 1) {
        const star = document.createElement('span');
        const angle = (Math.PI * 2 * i) / 7 + Math.random() * 0.5;
        const distance = 22 + Math.random() * 18;
        star.className = 'forest-map-sparkle';
        star.textContent = '✦';
        star.setAttribute('aria-hidden', 'true');
        star.style.left = `${x}px`;
        star.style.top = `${y}px`;
        star.style.color = sparkleColors[i % sparkleColors.length];
        star.style.setProperty('--dx', `${Math.cos(angle) * distance}px`);
        star.style.setProperty('--dy', `${Math.sin(angle) * distance - 8}px`);
        star.addEventListener('animationend', () => star.remove());
        map.appendChild(star);
      }
    };

    const closeBubble = (bubble) => {
      clearTimeout(bubble._timer);
      bubble.classList.remove('is-visible');
      bubble.dataset.spot = '';
      bubble.closest('[data-map-image]')
        ?.querySelectorAll('[data-bear-talk]')
        .forEach((spot) => spot.setAttribute('aria-expanded', 'false'));
      bubble._hideTimer = setTimeout(() => {
        if (!bubble.classList.contains('is-visible')) bubble.hidden = true;
      }, 250);
    };

    const openBubble = (map, bubble, spot) => {
      clearTimeout(bubble._timer);
      clearTimeout(bubble._hideTimer);

      const text = bubble.querySelector('[data-bear-bubble-text]');
      const image = bubble.querySelector('[data-bear-bubble-image]');
      text.textContent = spot.dataset.bearMessage || '';
      if (spot.dataset.bearImage) {
        image.onload = () => placeBubble(map, bubble, spot);
        image.src = spot.dataset.bearImage;
        image.hidden = false;
      } else {
        image.onload = null;
        image.removeAttribute('src');
        image.hidden = true;
      }

      map.querySelectorAll('[data-bear-talk]').forEach((other) => other.setAttribute('aria-expanded', 'false'));
      spot.setAttribute('aria-expanded', 'true');
      bubble.dataset.spot = spot.getAttribute('aria-label');

      bubble.classList.remove('is-visible');
      bubble.hidden = false;
      placeBubble(map, bubble, spot);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => bubble.classList.add('is-visible'));
      });
      sparkle(map, spot);
      bubble._timer = setTimeout(() => closeBubble(bubble), 6000);
    };

    document.addEventListener('click', (event) => {
      const scrollLink = event.target.closest('[data-map-scroll]');
      if (scrollLink) {
        const target = document.querySelector(scrollLink.dataset.mapScroll);
        if (target) {
          event.preventDefault();
          target.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' });
        }
        return;
      }

      const spot = event.target.closest('[data-bear-talk]');
      if (spot) {
        const map = spot.closest('[data-map-image]');
        const bubble = map?.querySelector('[data-bear-bubble]');
        if (!bubble) return;
        if (bubble.classList.contains('is-visible') && bubble.dataset.spot === spot.getAttribute('aria-label')) {
          closeBubble(bubble);
        } else {
          openBubble(map, bubble, spot);
        }
        return;
      }

      document.querySelectorAll('[data-bear-bubble].is-visible').forEach(closeBubble);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-bear-bubble].is-visible').forEach(closeBubble);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest('[data-menu-drawer-open]');
    if (openTrigger) {
      document.getElementById(openTrigger.getAttribute('data-menu-drawer-open'))?.showModal();
      return;
    }

    const closeTrigger = event.target.closest('[data-menu-drawer-close]');
    if (closeTrigger) {
      closeTrigger.closest('dialog')?.close();
      return;
    }

    if (event.target.classList?.contains('menu-drawer')) {
      event.target.close();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-simple"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-variant-select]');
    if (!select) return;

    const option = select.selectedOptions[0];
    const variantInput = document.querySelector('[data-purchase-bar-variant-input]');
    const priceEl = document.querySelector('[data-purchase-bar-price]');

    if (variantInput) variantInput.value = select.value;
    if (priceEl && option) priceEl.textContent = option.dataset.price;
  });

  document.addEventListener('click', (event) => {
    const decrementBtn = event.target.closest('[data-quantity-decrement]');
    const incrementBtn = event.target.closest('[data-quantity-increment]');
    if (!decrementBtn && !incrementBtn) return;

    const quantityInput = (decrementBtn || incrementBtn)
      .closest('.product-simple-purchase-bar__quantity')
      .querySelector('[data-quantity-input]');
    const min = parseInt(quantityInput.min, 10) || 1;
    const currentValue = parseInt(quantityInput.value, 10) || min;

    quantityInput.value = decrementBtn ? Math.max(min, currentValue - 1) : currentValue + 1;
  });

  document.addEventListener('click', (event) => {
    const buyNowBtn = event.target.closest('[data-buy-now]');
    if (!buyNowBtn) return;

    const form = buyNowBtn.closest('form');
    buyNowBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
    })
      .then(() => {
        window.location.href = '/checkout';
      })
      .catch(() => {
        buyNowBtn.disabled = false;
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-variant-select]');
    if (!select) return;

    const option = select.selectedOptions[0];
    const variantInput = document.querySelector('[data-purchase-bar-variant-input]');
    const priceEl = document.querySelector('[data-purchase-bar-price]');

    if (variantInput) variantInput.value = select.value;
    if (priceEl && option) priceEl.textContent = option.dataset.price;
  });

  document.addEventListener('click', (event) => {
    const decrementBtn = event.target.closest('[data-quantity-decrement]');
    const incrementBtn = event.target.closest('[data-quantity-increment]');
    if (!decrementBtn && !incrementBtn) return;

    const quantityInput = (decrementBtn || incrementBtn)
      .closest('.product-purchase-bar__quantity')
      .querySelector('[data-quantity-input]');
    const min = parseInt(quantityInput.min, 10) || 1;
    const currentValue = parseInt(quantityInput.value, 10) || min;

    quantityInput.value = decrementBtn ? Math.max(min, currentValue - 1) : currentValue + 1;
  });

  } catch(e) { console.error(e); }
})();
})();
